export default __webpack_public_path__ + "static/media/ic_date_range_week.13cd396c.svg";